import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import { Card } from '@/components/ui/card';
import { Kontakt } from '@/domain/mitarbeiter/features/anlageassistent/content/Zusammenfassung/Kontakt';
import { Persoenliches } from '@/domain/mitarbeiter/features/anlageassistent/content/Zusammenfassung/Persoenliches';

import { faUser } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export function Zusammenfassung() {
  return (
    <div className="flex flex-col items-start lg:flex-row gap-8 p-4 md:p-0">
      <div className="md:w-96 w-full">
        <Card className="p-5 bg-neutrals-100 rounded-3xl shadow-lg">
          <div className="flex flex-col gap-3">
            <Avatar className="size-16">
              <AvatarFallback>
                <FontAwesomeIcon icon={faUser} className="size-5" />
              </AvatarFallback>
            </Avatar>
            <Persoenliches />
            <Kontakt />
          </div>
        </Card>
      </div>
      <div className="grow"></div>
    </div>
  );
}
